var render = function render(_c,_vm){return _c('div',{},[_c('div',{staticClass:"flex flex-row items-start"},[_c('div',{staticClass:"font-bold text-white mt-2",style:({
        'vertial-align': 'sub',
        'font-size': '40px',
      })},[_vm._v(" $ ")]),_c('div',{staticClass:"font-bold text-white pb-1",style:({
        'font-size': '68px',
        'vertial-align': 'sub',
      })},[_vm._v(" "+_vm._s(_vm.props.price)+" ")]),_c('div',{staticClass:"ml-2 mt-12 ds-text-sm font-bold text-white"},[_vm._v("/ year")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }